export default __webpack_public_path__ + "static/media/adduser-aqua.6ff9aaad.svg";